import { Trophy } from 'lucide-react';
import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card';
import { Typography } from '@/components/ui/typography';

const SwimmersDiaryStub = () => {
  return (
    <Card className="overflow-hidden border-b">
      <CardHeader className="w-[calc(100vw-1.5rem)] md:w-[calc(100vw-250px-1.5rem)] lg:w-[50.4rem]  px-0 pt-0 border-b  bg-gradient-to-r from-primary/5 to-primary/10">
        <div className="flex flex-col">
          <div className="group flex  items-center gap-3 mr-auto pl-6 pt-6">
            <div className="p-3 rounded-lg bg-primary/10 text-primary">
              <Trophy className="w-6 h-6" />
            </div>
            <Typography
              variant="h3"
              className="text-lg font-normal text-gray-800 group-hover:text-primary transition-colors">
              Дневник Пловца
            </Typography>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4 px-0 pb-0">
        <div className="relative">
          {/* Фоновый градиент */}
          <div className="absolute -inset-1  rounded-xl blur-md opacity-20" />

          {/* Контент */}
          <div className="relative max-w-[1000px] mx-auto  p-6 rounded-xl">
            <Typography variant="p" className="text-base leading-relaxed">
              Это ключевой элемент методики АкваСтар. После каждого занятия инструктор фиксирует
              достижения, чтобы вы могли видеть, как уверенно растут навыки вашего ребенка.
            </Typography>
            <Typography variant="muted" className="mt-4 block">
              Приобрести дневник можно у администратора. В этом разделе будут отображаться все
              освоенные умения.
            </Typography>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SwimmersDiaryStub;
